'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ = require('../');
var _constants = require('../../constants');
var _checkers = require('../../utils/checkers');
var _SaveSearchLocationModal = require('./SaveSearchLocationModal.scss');var styles = _interopRequireWildcard(_SaveSearchLocationModal);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

SaveSearchLocationModal = function (_Component) {_inherits(SaveSearchLocationModal, _Component);function SaveSearchLocationModal() {var _temp, _this, _ret;_classCallCheck(this, SaveSearchLocationModal);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    onFormClose = function () {
      if (_this.props.isLoggedIn && (0, _checkers.isTemporaryEmail)(_this.props.userAuthentication.data.email)) {
        _this.props.logOut();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);}SaveSearchLocationModal.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_reactModal2.default, {
          isOpen: this.props.isOpen,
          contentLabel: 'save-current-location',
          style: Object.assign({}, _constants.centeredModalStyle, {

            overlay: Object.assign({},
            _constants.centeredModalStyle.overlay, {
              zIndex: 12 }) }),


          className:
          (0, _classnames2.default)(styles.saveSearchModalContent, { rtl: this.props.isRtl }),

          onRequestClose: this.props.close },

        this.props.isOpen &&
        _react2.default.createElement(_.SaveSearchLocationForm, {
          translate: this.props.translate,
          close: this.props.close,
          routeData: this.props.routeData,
          initialValues: { email: (0, _get2.default)(this.props, 'userAuthentication.data.email') },
          isRtl: this.props.isRtl,
          socialNetworkAuthentication: this.props.socialNetworkAuthentication,
          isLoggedIn: this.props.isLoggedIn,
          saveSearchData: this.props.saveSearchData,
          auth: this.props.auth,
          openAuthenticationModal: this.props.openAuthenticationModal,
          editUserProfile: this.props.editUserProfile,
          userToken: this.props.userToken,
          userAuthenticationError: this.props.userAuthentication.error,
          onFormClose: this.onFormClose,
          isMobile: this.props.isMobile,
          locale: this.props.locale })));




  };return SaveSearchLocationModal;}(_react.Component);


SaveSearchLocationModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  saveSearchData: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isLoggedIn: _propTypes2.default.bool,
  close: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  auth: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  userAuthentication: _propTypes2.default.object,
  routeData: _propTypes2.default.object,
  logOut: _propTypes2.default.func,
  locale: _propTypes2.default.string };exports.default =


SaveSearchLocationModal;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SaveSearchLocationModal/SaveSearchLocationModal.js
// module id = 2900
// module chunks = 0